module.exports = __webpack_public_path__ + "static/media/ryzen.489df2d5.png";